import React from "react";
import StaticText from "../components/StaticText";
import {Button, Form, Input, Message, Segment} from "semantic-ui-react";
import {connect} from "react-redux";
import * as StaticActions from "../actions/StaticActions";

class RightTopText extends React.Component {

    state = {
        mail: "",
    };

    saveMail() {
        const {mail} = this.state;
        this.props.saveEmail(mail);
        this.setState({mail: ""});
    }

    render() {

        const {mail} = this.state;
        const {saving, saved} = this.props.newsletterStatus;

        return <div className="website-intro">

            {/*<Segment>*/}

                <StaticText label="website-intro"/><br/>

            <Message error={true}>
                SailScanner is not being actively developed or maintained at the moment.
            </Message><br />

                {/*<ul className="legend">*/}
                    {/*<li>Available route</li>*/}
                    {/*<li className="requested">Requested route</li>*/}
                {/*</ul>*/}
            {/*</Segment>*/}

            {/*{saved ? <div>*/}
                    {/*<em>Thanks, we'll let you know!</em>*/}
                {/*</div> :*/}
                {/*<Form onSubmit={() => this.saveMail()}>*/}
                    {/*<small><strong>Like to receive updates on Sailscanner?</strong></small><br />*/}
                    {/*<Form.Group>*/}
                        {/*<Form.Input value={mail} onChange={(e) => this.setState({mail: e.target.value})} size="mini"*/}
                               {/*placeholder="E-mail address"/>*/}
                        {/*<Form.Button type="submit" loading={saving} size="mini">Sign up</Form.Button>*/}
                    {/*</Form.Group>*/}
                {/*</Form>*/}
            {/*}*/}
        </div>

    }
}


export default connect(state => ({
    newsletterStatus: state.staticTexts.newsletter,
}), dispatch => ({
    saveEmail: (mail) => dispatch(StaticActions.saveNewsletterMail(mail)),
}))(RightTopText)


// WEBPACK FOOTER //
// ./src/components/RightTopText.js